module.exports = __webpack_public_path__ + "static/img/target-oxbridge-podcast.62f801b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/target-oxbridge-podcast.png
// module id = Mo+H
// module chunks = 0